import { render, staticRenderFns } from "./DynamicMessage.vue?vue&type=template&id=f5101faa&scoped=true&lang=html"
import script from "./DynamicMessage.vue?vue&type=script&lang=js"
export * from "./DynamicMessage.vue?vue&type=script&lang=js"
import style0 from "./DynamicMessage.vue?vue&type=style&index=0&id=f5101faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5101faa",
  null
  
)

export default component.exports